$(function(){
    var lastScrollTop = 0, delta = 15;
    let heightHead = $("header").height() + $(".announcement-bar").height();
   
    let heightAnonc = $(".announcement-bar").height();
    $(window).scroll(function(event){
      if( $('header nav').hasClass('js-menu--is-open') != true && $('.go-cart__drawer').hasClass('is-open') != true ){
       var st = $(this).scrollTop();
       
       if(Math.abs(lastScrollTop - st) <= delta)
          return;
        if ((st > lastScrollTop) && (lastScrollTop>0)) {
               // downscroll code
              $("header").css("top","-"+heightHead+"px");
              $(".announcement-bar").css("top","-"+heightAnonc+"px");
            
           } else {
              // upscroll code
              $("header").css("top","0px");
             $(".announcement-bar").css("top","0px");
           }
       lastScrollTop = st;
      }
    });
});